/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventAccess } from './EventAccess';
import {
    EventAccessFromJSON,
    EventAccessFromJSONTyped,
    EventAccessToJSON,
    EventAccessToJSONTyped,
} from './EventAccess';
import type { ScoringMode } from './ScoringMode';
import {
    ScoringModeFromJSON,
    ScoringModeFromJSONTyped,
    ScoringModeToJSON,
    ScoringModeToJSONTyped,
} from './ScoringMode';
import type { EventState } from './EventState';
import {
    EventStateFromJSON,
    EventStateFromJSONTyped,
    EventStateToJSON,
    EventStateToJSONTyped,
} from './EventState';
import type { JudgingMode } from './JudgingMode';
import {
    JudgingModeFromJSON,
    JudgingModeFromJSONTyped,
    JudgingModeToJSON,
    JudgingModeToJSONTyped,
} from './JudgingMode';
import type { EventParticipation } from './EventParticipation';
import {
    EventParticipationFromJSON,
    EventParticipationFromJSONTyped,
    EventParticipationToJSON,
    EventParticipationToJSONTyped,
} from './EventParticipation';
import type { FeedbackLevel } from './FeedbackLevel';
import {
    FeedbackLevelFromJSON,
    FeedbackLevelFromJSONTyped,
    FeedbackLevelToJSON,
    FeedbackLevelToJSONTyped,
} from './FeedbackLevel';

/**
 * Schema for reading an event.
 * @export
 * @interface EventRead
 */
export interface EventRead {
    /**
     * 
     * @type {string}
     * @memberof EventRead
     */
    competition_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventRead
     */
    name: string;
    /**
     * 
     * @type {EventParticipation}
     * @memberof EventRead
     */
    participation?: EventParticipation;
    /**
     * 
     * @type {EventAccess}
     * @memberof EventRead
     */
    access?: EventAccess;
    /**
     * 
     * @type {Date}
     * @memberof EventRead
     */
    available_start: Date;
    /**
     * 
     * @type {Date}
     * @memberof EventRead
     */
    available_end: Date;
    /**
     * 
     * @type {number}
     * @memberof EventRead
     */
    duration_minutes?: number | null;
    /**
     * 
     * @type {ScoringMode}
     * @memberof EventRead
     */
    scoring_mode?: ScoringMode;
    /**
     * 
     * @type {number}
     * @memberof EventRead
     */
    max_team_size?: number;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventRead
     */
    feedback?: FeedbackLevel;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventRead
     */
    feedback_after_close?: FeedbackLevel;
    /**
     * 
     * @type {JudgingMode}
     * @memberof EventRead
     */
    judging_mode?: JudgingMode;
    /**
     * 
     * @type {number}
     * @memberof EventRead
     */
    judging_radius?: number;
    /**
     * 
     * @type {number}
     * @memberof EventRead
     */
    judging_tolerance?: number;
    /**
     * 
     * @type {string}
     * @memberof EventRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventRead
     */
    created_by: string;
    /**
     * 
     * @type {Date}
     * @memberof EventRead
     */
    created_at: Date;
    /**
     * 
     * @type {EventState}
     * @memberof EventRead
     */
    state: EventState;
    /**
     * 
     * @type {number}
     * @memberof EventRead
     */
    organizations_count?: number;
    /**
     * 
     * @type {number}
     * @memberof EventRead
     */
    competitors_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventRead
     */
    is_administrator: boolean;
}



/**
 * Check if a given object implements the EventRead interface.
 */
export function instanceOfEventRead(value: object): value is EventRead {
    if (!('competition_id' in value) || value['competition_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('available_start' in value) || value['available_start'] === undefined) return false;
    if (!('available_end' in value) || value['available_end'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('is_administrator' in value) || value['is_administrator'] === undefined) return false;
    return true;
}

export function EventReadFromJSON(json: any): EventRead {
    return EventReadFromJSONTyped(json, false);
}

export function EventReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventRead {
    if (json == null) {
        return json;
    }
    return {
        
        'competition_id': json['competition_id'],
        'name': json['name'],
        'participation': json['participation'] == null ? undefined : EventParticipationFromJSON(json['participation']),
        'access': json['access'] == null ? undefined : EventAccessFromJSON(json['access']),
        'available_start': (new Date(json['available_start'])),
        'available_end': (new Date(json['available_end'])),
        'duration_minutes': json['duration_minutes'] == null ? undefined : json['duration_minutes'],
        'scoring_mode': json['scoring_mode'] == null ? undefined : ScoringModeFromJSON(json['scoring_mode']),
        'max_team_size': json['max_team_size'] == null ? undefined : json['max_team_size'],
        'feedback': json['feedback'] == null ? undefined : FeedbackLevelFromJSON(json['feedback']),
        'feedback_after_close': json['feedback_after_close'] == null ? undefined : FeedbackLevelFromJSON(json['feedback_after_close']),
        'judging_mode': json['judging_mode'] == null ? undefined : JudgingModeFromJSON(json['judging_mode']),
        'judging_radius': json['judging_radius'] == null ? undefined : json['judging_radius'],
        'judging_tolerance': json['judging_tolerance'] == null ? undefined : json['judging_tolerance'],
        'id': json['id'],
        'created_by': json['created_by'],
        'created_at': (new Date(json['created_at'])),
        'state': EventStateFromJSON(json['state']),
        'organizations_count': json['organizations_count'] == null ? undefined : json['organizations_count'],
        'competitors_count': json['competitors_count'] == null ? undefined : json['competitors_count'],
        'is_administrator': json['is_administrator'],
    };
}

export function EventReadToJSON(json: any): EventRead {
    return EventReadToJSONTyped(json, false);
}

export function EventReadToJSONTyped(value?: EventRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competition_id': value['competition_id'],
        'name': value['name'],
        'participation': EventParticipationToJSON(value['participation']),
        'access': EventAccessToJSON(value['access']),
        'available_start': ((value['available_start']).toISOString()),
        'available_end': ((value['available_end']).toISOString()),
        'duration_minutes': value['duration_minutes'],
        'scoring_mode': ScoringModeToJSON(value['scoring_mode']),
        'max_team_size': value['max_team_size'],
        'feedback': FeedbackLevelToJSON(value['feedback']),
        'feedback_after_close': FeedbackLevelToJSON(value['feedback_after_close']),
        'judging_mode': JudgingModeToJSON(value['judging_mode']),
        'judging_radius': value['judging_radius'],
        'judging_tolerance': value['judging_tolerance'],
        'id': value['id'],
        'created_by': value['created_by'],
        'created_at': ((value['created_at']).toISOString()),
        'state': EventStateToJSON(value['state']),
        'organizations_count': value['organizations_count'],
        'competitors_count': value['competitors_count'],
        'is_administrator': value['is_administrator'],
    };
}

